(() => {
  function init(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = 'true';
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const track = root.querySelector('.sh-ingredient-track');
    if (track) {
      const cards = [...track.children];
      const current = () => cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left - track.getBoundingClientRect().left - 20) < Math.abs(cards[best].getBoundingClientRect().left - track.getBoundingClientRect().left - 20) ? i : best, 0);
      const go = delta => {
        const index = Math.max(0, Math.min(cards.length - 1, current() + delta));
        track.scrollTo({ left: cards[index].offsetLeft - cards[0].offsetLeft, behavior: reduced ? 'instant' : 'smooth' });
      };
      root.querySelector('[data-sh-prev]').addEventListener('click', () => go(-1));
      root.querySelector('[data-sh-next]').addEventListener('click', () => go(1));
      track.addEventListener('keydown', e => { if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go(e.key === 'ArrowRight' ? 1 : -1); } });
      let pending = false;
      track.addEventListener('scroll', () => {
        if (pending) return; pending = true;
        requestAnimationFrame(() => { pending = false; const n = current(); root.querySelector('[data-sh-progress]').textContent = `0${n + 1} / 03`; root.querySelector('[data-sh-progress-bar]').style.transform = `translateX(${n * 100}%)`; });
      }, { passive: true });
    }
    root.querySelectorAll('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
      if (a.getAttribute('href') === '#sting-buy') return;
      const target = document.querySelector(a.getAttribute('href'));
      if (!target) return;
      e.preventDefault(); target.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
      history.replaceState(null, '', a.getAttribute('href'));
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    }));
  }
  function initScrollReveals() {
    const main = document.getElementById('MainContent');
    if (!main?.querySelector('[data-sting-story]') || main.dataset.scrollReveals || window.Shopify?.designMode) return;
    main.dataset.scrollReveals = 'true';
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    if (preference.matches || !('IntersectionObserver' in window)) return;
    const selector = [
      '.sh-marquee', '.sh-ingredients .sh-section-head > *',
      '.sh-ingredient > *', '.sh-track-progress', '.sh-science-note',
      '.sh-fuel-grid > *', '.ss-toolbar', '.ss-card', '.ss-footer',
      '.sh-calorie-heading', '.sh-calorie-serving',
      '.sh-taste-image', '.sh-taste-copy > *',
      '.sting-feel__copy > .sh-eyebrow', '.sting-feel__copy > h2',
      '.sting-feel__benefits > *', '.sting-feel__quote',
      '.sh-honey__header', '.sh-honey__track', '.sh-honey__controls',
      '.sh-buy-top > *', '.sh-gallery > *',
      '.sh-buy-grid > div > .sh-proof', '.sh-buy-title', '.sh-buy-intro',
      '.sh-plan', '.wb-cart-summary-wrap', '.sh-gift-link', '.sh-buy-foot',
      '.sh-faq .sh-wrap > *', '.wb-instagram .wb-wrap > *',
      '.sh-vision-grid > *', '.sh-wordmark', '.sh-footer-bottom',
      'footer.footer .footer__content-bottom'
    ].join(',');
    const targets = [...document.querySelectorAll(selector)];
    const timers = new Map();
    const show = (node, immediate = false) => {
      observer.unobserve(node);
      clearTimeout(timers.get(node));
      timers.delete(node);
      if (immediate) {
        node.classList.remove('sh-scroll-reveal', 'sh-scroll-visible');
        node.style.removeProperty('--sh-reveal-delay');
        return;
      }
      node.classList.add('sh-scroll-visible');
      timers.set(node, setTimeout(() => show(node, true), 1400));
    };
    const observer = new IntersectionObserver(entries => {
      const entering = entries.filter(entry => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top || a.boundingClientRect.left - b.boundingClientRect.left);
      let previousTop = -Infinity;
      let step = 0;
      entering.forEach(entry => {
        const top = entry.boundingClientRect.top;
        step = Math.abs(top - previousTop) < 100 ? Math.min(step + 1, 2) : 0;
        entry.target.style.setProperty('--sh-reveal-delay', `${100 + step * 110}ms`);
        previousTop = top;
        show(entry.target);
      });
    }, { threshold: 0, rootMargin: matchMedia('(max-width: 749px)').matches ? '0px' : `0px 0px -${Math.round(innerHeight * .16)}px 0px` });
    targets.forEach(node => {
      const box = node.getBoundingClientRect();
      if (!box.height || box.bottom <= 0 || (box.top < innerHeight * .88 && box.left < innerWidth && box.right > 0)) return;
      node.classList.add('sh-scroll-reveal');
      observer.observe(node);
    });
    document.addEventListener('focusin', event => {
      const node = event.target.closest?.('.sh-scroll-reveal');
      if (node) show(node, true);
    });
    const showAll = () => targets.forEach(node => show(node, true));
    preference.addEventListener('change', () => { if (preference.matches) showAll(); });
    window.addEventListener('pageshow', event => { if (event.persisted) showAll(); });
    document.addEventListener('shopify:section:load', showAll);
  }
  document.querySelectorAll('[data-sting-story]').forEach(init);
  initScrollReveals();
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-sting-story]')));
})();

